export enum ExtendedWaveParticipationRequirement {
  NONE = "NONE",
  IMAGE = "IMAGE",
  AUDIO = "AUDIO",
  VIDEO = "VIDEO",
}
